import FixedBottomNavigation from '../components/bottomNavigation/bottomNavigation';
import CustomizedAppBar from '../components/appBar/CustomizedAppBar';

const MainLayout = () => {
    return (
        <>
            <CustomizedAppBar />
            <FixedBottomNavigation />
        </>
    );
};

export default MainLayout;
